/* eslint-disable no-unused-vars */
import DateRangePicker from 'rsuite/DateRangePicker';
import { useEffect, useMemo } from 'react';

const { allowedMaxDays, afterToday, combine } = DateRangePicker;

function DateRangePickerRsuit(props) {
	const {
		MAX,
		dateRanges,
		disabled,
		enableOnlyBackwardSelection = true,
		onDateRangeChange,
		menuStyles = {},
		placement = 'bottomEnd',
		width = 250,
		customStyle = false,
		cleanable = false,
		onChange = () => {},
	} = props;

	const valueChanged = (startAndEndDateArray) => {
		onDateRangeChange({
			selection: {
				startDate: startAndEndDateArray[0],
				endDate: startAndEndDateArray[1],
			},
		});
		// onDateRangeChange(startAndEndDateArray);
	};

	useEffect(() => {
		const observer = new MutationObserver(() => {
			const popup = document.querySelector('.rs-picker-popup.rs-picker-popup-daterange');
			if (popup) {
				popup.style.zIndex = '5000';
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});

		return () => observer.disconnect();
	}, []);

	const typeDisable = useMemo(() => {
		if (MAX && enableOnlyBackwardSelection) {
			return combine(afterToday(), allowedMaxDays(MAX));
		}
		if (MAX) return allowedMaxDays(MAX);
		if (enableOnlyBackwardSelection) return afterToday();
		return null;
	}, [MAX, enableOnlyBackwardSelection]);
	// const val=[]
	return (
		<DateRangePicker
			isoWeek
			disabled={!!disabled}
			ranges={[]}
			placement={placement}
			format='dd-MM-yyyy'
			placeholder='Start Date  --  End Date'
			// null (not [null, null]) is rsuite's "no range": a cleared or not-yet-picked range
			value={dateRanges[0].startDate && dateRanges[0].endDate
				? [dateRanges[0].startDate, dateRanges[0].endDate]
				: null}
			shouldDisableDate={typeDisable}
			onOk={valueChanged}
			showWeekNumbers
			style={{
				width,
			}}
			onChange={onChange}
			cleanable={cleanable}
			menuStyle={menuStyles}
			className={customStyle ? 'date-range-picker-custom' : ''}
		/>
	);
}
DateRangePickerRsuit.defaultProps = {
	dateRanges: [
		{
			startDate: new Date(),
			endDate: new Date(),
			key: 'selection',
		},
	],
	onDateRangeChange: () => {},
	width: 250,
	customStyle: false,
};

// export default connect(mapStateToProps, mapDispatchToProps)(DateRangePickerRsuit);
export default DateRangePickerRsuit;
